import { GeneralQueryErrorResultCreator, MissingQueryDataResultCreator, NonOkQueryResultCreator } from '../../graphql-result';
/** The requester to make query operation to App Recommendations API via AGG
 *
 * Currently, App Recommendations Service has only a single query (and we only use a single query), which doesn't return any Query errors
 * @see {@link https://developer.atlassian.com/platform/graphql-gateway/standards/query-error/} for more about query errors
 * The query error checking is skipped for now, but it can be added in the future if needed
 */
export default class Requester {
  constructor(broker) {
    this.broker = broker;
  }
  fetch(request) {
    return new Promise(async (resolve, reject) => {
      var _json$data;
      const response = await fetch(request);
      if (!response.ok) {
        return reject(new NonOkQueryResultCreator(response).makeQueryResult());
      }
      const json = await response.json();
      if (json.errors) {
        return reject(new GeneralQueryErrorResultCreator(json.errors).makeQueryResult());
      }
      const schemaResponse = json === null || json === void 0 ? void 0 : (_json$data = json.data) === null || _json$data === void 0 ? void 0 : _json$data.growthRecommendations;
      const queryRes = this.broker.extract(schemaResponse);

      // Undefined is not expected as a valid response from GraphQL
      if (queryRes === undefined) {
        return reject(new MissingQueryDataResultCreator(response).makeQueryResult());
      }
      return resolve(this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult());
    });
  }
}